// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 25","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"font-background"},"nodeName":"g","children":[{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M4 21.3135H20V22.3135H4V21.3135Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"fill1","fill":"transparent","d":"M12.414 1.41406L20.8993 9.89934L12.414 18.3846L3.92871 9.89934L12.414 1.41406Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M12.414 1.41406L20.8993 9.89934L12.414 18.3846L3.92871 9.89934L12.414 1.41406Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M6.75725 12.7275L9.58568 15.556L8.17147 16.9702H5.34304L3.92883 15.556L6.75725 12.7275Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]}]};

@tag('t-icon-font-background')
export default class FontBackgroundIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'font-background',
    }
  }
}
